import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
//assets
import NoBackground from "../../../assets/background/no-img.png";

import { Description } from "../Accordions/Description";
import { Layout } from "../Accordions/Layout";
import { ColorsAndTag } from "../Accordions/ColorsAndTag";
import { useState } from "react";

type CreatedArtProps = {
  goBack: () => void;
};

export function CreatedArt({ goBack }: CreatedArtProps) {
  const [currentAccordion, setCurrentAccordion] = useState<number | false>(0);

  const handleChangeAccordion = (panel: number) => (isExpanded: boolean) => {
    setCurrentAccordion(isExpanded ? panel : false);
  };

  return (
    <Stack spacing={4} direction="row" justifyContent="center" px={12}>
      <Stack spacing={1}>
        <img alt="img-background" src={NoBackground} />
        <Button variant="outlined">Escolher fundo</Button>
      </Stack>
      <Stack spacing={2}>
        <Description
          onChange={handleChangeAccordion(0)}
          expanded={currentAccordion === 0}
        />
        <Layout
          onChange={handleChangeAccordion(1)}
          expanded={currentAccordion === 1}
        />
        <ColorsAndTag
          onChange={handleChangeAccordion(2)}
          expanded={currentAccordion === 2}
        />
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={goBack} color="inherit">
            Voltar
          </Button>
          <Button variant="contained" disabled>
            Gerar arte
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}
